import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, Material, ProductPreviewComponent, ShoppingcartService, TranslationPipe } from '@prekog/common-ui';
import { STORE_BACKEND_URL } from '../app.config';
import { GetOnSaleProductsResponse } from './get-on-sale-products.response';
import { OnSalePeriodProduct } from './on-sale-period-product.model';
import { ProductOnSale } from './product-on-sale.model';

@Component({
    selector: 'pf-on-sale-products',
    templateUrl: './onsaleproducts.component.html',
    styleUrl: './onsaleproducts.component.scss',
    standalone: true,
    imports: [CommonModule, MatIconModule, TranslationPipe, RouterModule, ProductPreviewComponent]
})
export class OnSaleProductsComponent {
    getHomeConfigByComponentUrl = '/websiteconfigurator/find-homeconfig';
    getOnSaleProductsUrl = '/store/getOnSaleProducts';
    readonly onSalePeriodProductList = computed(() => {
        const response = this._onSaleProductsResponse();
        return (response?.onSalePeriodProductList ?? []) as OnSalePeriodProduct[];
    });
    router = inject(Router);
    private readonly _apiRequestService = inject(ApiRequestService);
    private readonly _storeBackendUrl = inject<string>(STORE_BACKEND_URL);
    private readonly _onSaleProductsResponse = toSignal(
        this._apiRequestService.sendRequest<object, GetOnSaleProductsResponse>(this._storeBackendUrl, {}, true, this.getOnSaleProductsUrl),
        { initialValue: null }
    );
    private readonly _shoppingCartService = inject(ShoppingcartService);

    addToCartDiscountedBook(material: Material): void {
        this._shoppingCartService.addToCart(material);
    }

    mapToMaterial(product: ProductOnSale): Material {
        return {
            ...structuredClone(product),
            oldPrice: product.originalPrice,
            originalPrice: product.discountPrice,
            discountPriceActive: true
        } as Material;
    }
}
